// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-wrapper[data-v-065d706c]{position:relative;display:inline-block}.image-wrapper img[data-v-065d706c]{display:block;width:700px;height:auto;border-radius:24px}@media (max-width:768px){.image-wrapper img[data-v-065d706c]{width:100%;max-width:100%}}.overlay[data-v-065d706c]{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(100,0,255,.2);z-index:0;pointer-events:none;border-radius:24px}", ""]);
// Exports
module.exports = exports;
